<template lang="pug">
	.matrixBool
		input(:id="`${header._id}_true`" type="radio", :name="`${header._id}_bool`", value="true", @input="input", :checked="value === true")
		label(:for="`${header._id}_true`") Yes
		input(:id="`${header._id}_false`" type="radio", :name="`${header._id}_bool`", value="false", @input="input", :checked="value === false")
		label(:for="`${header._id}_false`") No
		input(:id="`${header._id}_null`" type="radio", :name="`${header._id}_bool`", value="null", @input="input", :checked="value === null")
		label(:for="`${header._id}_null`") [unset]
</template>

<script>
export default {
  name: "MatrixBool",
  props: ["value", "header"],
  methods: {
    input(e) {
			let val
			if (e.target.value === 'true') val = true
			if (e.target.value === 'false') val = false
			if (e.target.value === 'null') val = null
      this.$emit("input", val);
    }
  }
};
</script>

<style lang="scss" scoped>
.matrixBool {
  display: flex;
  background: #fafafa;
  justify-content: center;
  align-items: center;
  position: relative;
	padding: 20px;
	flex: 1 1 100%;
	border: 1px solid #c4c4c4;
	border-radius: 2px;
}

input {
  position: absolute;
  top: 0;
  left: 0;
  height: 0;
  width: 0;
  opacity: 0;
  background: transparent;
  border: none;
  outline: none;
  appearance: none;
  margin-bottom: 0;
  &:checked + label {
    &::before {
      box-shadow: inset 0 0 0 3px $white;
    }
  }
}

label {
  display: flex;
  font-size: 16px;
  align-items: center;
  margin-right: 30px;
  margin-bottom: 0;
  cursor: pointer;
  &::before {
    content: "";
    height: 12px;
    width: 12px;
    border-radius: 50%;
		background: $cobalt;
		border: 1px solid $cobalt;
    margin-right: 5px;
    box-shadow: inset 0 0 0 6px $white;
    transition: 0.1s ease;
  }
}
</style>